import memoize from 'lru-memoize';
import { createValidator, required, minLength, maxLength } from '../../utils/validation';

const saveAccountValidation = createValidator({
  firstName: required,
  lastName: required,
  address: required,
  city: required,
  state: required,
  zipCode: required,
  routingNumber: [required, minLength(9), maxLength(9)],
  accountNumber: required,
  accountType: required,
  bankName: required,
});
export default memoize(10)(saveAccountValidation);
